<template>
  <ion-page>
    <ion-content :fullscreen="true" class="bg-lighter ion-content">
      <vertical-nav-menu></vertical-nav-menu>
      <div class="nk-wrap">
        <nav-bar></nav-bar>
        <main-block>
          <block-head title="Assigned Leads" :description="'Total '+pagination.totalRecords+' leads.'"></block-head>
          <block-content>
            <card no-padding>
              <template v-slot:grouped>
                <div class="card-inner position-relative card-tools-toggle">
                  <card-header title="">
                    <card-tools>
                      <div class="form-inline flex-nowrap gx-3">
                        <div class="form-wrap w-150px">
                          <select class="form-select form-select-md form-control" v-model="bulkSelectedAction">
                            <option value="">Bulk Action</option>
                            <option value="withdraw">Withdraw</option>
                          </select>
                        </div>
                        <div class="btn-wrap">
                          <span class="d-none d-md-block">
                            <nk-button dim outline type="light" v-on:click="bulkAction" :disabled="!bulkSelectedAction.length">Apply</nk-button>
                          </span>
                          <span class="d-md-none">
                            <nk-button dim outline type="light" v-on:click="bulkAction" is-icon-only-button="" :disabled="!bulkSelectedAction.length">
                              <nio-icon icon="ni-arrow-right"></nio-icon>
                            </nk-button>
                          </span>
                        </div>
                      </div>
                    </card-tools>
                    <card-tools class="mr-n1">
                      <btn-toolbar>
                        <btn-toolbar-toggle-wrap id="advisors_toolbar">
                          <li>
                            <nk-button is-link type=""
                                       is-icon-only-button=""
                                       class="search-toggle"
                                       v-on:click="searchBarActive=true"
                                       :class="{active: searchBarActive}">
                              <nio-icon icon="ni-search"></nio-icon>
                            </nk-button>
                          </li>
                          <li class="btn-toolbar-sep"></li>
                          <li>
                            <drop-down
                                icon="ni-filter-alt"
                                size="lg"
                                direction="right"
                                :dot="( filters.status !== '' || filters.date !== '' ? 'primary':'')"
                                title="Leads Filter">
                              <template v-slot:body>
                                <row class="gx-6 gy-3">
                                  <column default="12">
                                    <label class="overline-title overline-title-alt" for="d_range_f">Date Range Filter</label>
                                    <vue-flatpickr v-model="filters.date" id="d_range_f" class="form-control" :config="vueFlatPickerConfig"></vue-flatpickr>
                                  </column>
                                  <column default="12" md="6">
                                    <label class="overline-title overline-title-alt" for="d_form_f">To Date</label>
                                    <b-select v-model="filters.form" id="d_form_f">
                                      <option value="">All</option>
                                      <option value="1">Other</option>
                                    </b-select>
                                  </column>
                                  <column default="12" md="6">
                                    <label class="overline-title overline-title-alt" for="d_status_f">Status</label>
                                    <b-select v-model="filters.status" id="d_status_f">
                                      <option value="">All</option>
                                      <option v-for="status in leadStatuses" :key="'ls'+status.id" :value="status.id">{{ status.status_text }}</option>
                                    </b-select>
                                  </column>
                                </row>
                              </template>
                              <template v-slot:footer>
                                <nk-button type="dark" dim v-on:click="getLeads(true)">Filter</nk-button>
                                <a class="clickable" href="javascript:;" v-on:click="[filters.status=filters.date='',getLeads(true)]">Reset Filter</a>
                              </template>
                            </drop-down>
                          </li><!-- li -->
                          <li>
                            <drop-down icon="ni ni-setting" title="" size="xs" direction="right">
                              <ul class="link-check">
                                <li><span>Order</span></li>
                                <li :class="{active: filters.display_order === 'asc'}"><a href="javascript:;" v-on:click="[filters.display_order='asc', getLeads(true)]">ASC</a></li>
                                <li :class="{active: filters.display_order === 'desc'}"><a href="javascript:;" v-on:click="[filters.display_order='desc', getLeads(true)]">DESC</a></li>
                              </ul>
                            </drop-down>
                          </li><!-- li -->
                        </btn-toolbar-toggle-wrap>
                      </btn-toolbar>
                    </card-tools>
                  </card-header>
                  <card-search
                      placeholder="Search: lead number/id, advisor name/email"
                      :is-active="searchBarActive"
                      @do-search="doSearch"
                      :search-term="filters.search"
                      @close-search="[searchBarActive=false, doSearch('')]"></card-search>
                </div>
                <div class="d-flex py-5 justify-center"  v-if="loadingData">
                  <ion-spinner></ion-spinner>
                </div>
                <template v-else>
                  <div class="card-inner p-0">
                    <special-table>
                      <table-row is-heading>
                        <table-col has-check-box>
                          <b-check-box id="select_all" v-model="selectAll"></b-check-box>
                        </table-col>
                        <table-col>
                          <span class="sub-text">Lead#</span>
                        </table-col>
                        <table-col>
                          <span class="sub-text">Assigned to</span>
                        </table-col>
                        <table-col break-point="mb">Lead</table-col>
                        <table-col break-point="md">Assign date</table-col>
                        <table-col break-point="lg">Opened</table-col>
                        <table-col break-point="lg">Current status</table-col>
                        <table-col class="nk-tb-col-tools"></table-col>
                      </table-row>

                      <table-row v-for="lead in leads" :key="'ld'+lead.id">
                        <table-col has-check-box>
                          <b-check-box :id="'lead'+lead.id" v-model="lead.selected" :key="'cb'+lead.id"></b-check-box>
                        </table-col>
                        <table-col>{{ lead.lead_number }}</table-col>
                        <table-col>
                          <user-small-card
                              :user-name="lead.advisor_f_name+' '+lead.advisor_l_name"
                              :user-email="lead.advisor_email" :image="lead.advisor_dp" :initials="lead.advisor_initials"></user-small-card>
                        </table-col>
                        <table-col break-point="mb">
                          <span class="tb-lead">{{ lead.first_name }}</span>
                          {{ lead.last_name }}
                        </table-col>
                        <table-col break-point="md">{{ lead.assign_date }}</table-col>
                        <table-col break-point="lg">{{ lead.opened_time }}</table-col>
                        <table-col break-point="lg">{{ lead.status_text }}</table-col>
                        <table-col class="nk-tb-col-tools">
                          <ul class="nk-tb-actions gx-1">
                            <li>
                              <drop-down-list>
                                <list-item icon="ni-eye" text="View Details" :to="{name: 'adminLeadDetails', params:{id:lead.id}}"></list-item>
                                <list-item icon="ni-curve-left-down" text="Withdraw" v-on:click="withdrawLeads([lead])"></list-item>
                              </drop-down-list>
                            </li>
                          </ul>
                        </table-col>
                      </table-row>

                    </special-table>

                  </div>
                  <div class="card-inner" v-if="pagination.totalRecords > 10">
                    <pagination
                        v-model="pagination.page"
                        :records="pagination.totalRecords"
                        :per-page="10"
                        @paginate="paginationCallback"
                        theme="bootstrap4"
                        :options="{chunk: 5, texts:{count: '||'}}"/>
                  </div>
                </template>
              </template>
            </card>
          </block-content>
        </main-block>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>

import {IonContent, IonPage, IonSpinner, alertController, loadingController, toastController} from '@ionic/vue';
import {defineComponent, onMounted, reactive, ref, watch} from 'vue';
import VerticalNavMenu from "@/@core/layouts/vertical-nav-menu/VerticalNavMenu";
import NavBar from "@core/layouts/app-nav-bar/NavBar";
import {BlockContent, BlockHead, MainBlock} from "@core/layouts";
import axios from "@/libs/axios"
import {Card, CardHeader, CardSearch, CardTools} from "@core/components/cards";

import { BtnToolbar, BtnToolbarToggleWrap } from "@core/components/btn-toolbar"
import "bootstrap"
import DropDown from "@core/components/dropdown/DropDown";

import { Column, Row } from "@core/layouts"

import Pagination from "v-pagination-3"
import {SpecialTable, TableCol, TableRow} from "@core/components/special-table";
import {BCheckBox, BSelect} from "@core/components/bp-form";
import UserSmallCard from "@/views/components/user-cards/UserSmallCard";
import {DropDownList, ListItem} from "@core/components/dropdown-list";
import { useStore } from "vuex"
import VueFlatpickr from "vue-flatpickr-component"
import 'flatpickr/dist/flatpickr.css';
import useDataChangeTracker from "@/store/data-change-tracker/dataChangeTracker"

export default defineComponent({
  components: {
    BSelect,
    ListItem,
    DropDownList,
    UserSmallCard,
    BCheckBox,
    SpecialTable,
    TableCol,
    TableRow,
    CardSearch,
    CardTools,
    BlockHead,
    Column,
    Row,
    DropDown,
    VueFlatpickr,
    BtnToolbar, BtnToolbarToggleWrap,
    CardHeader,
    Card,
    BlockContent,
    MainBlock,
    NavBar,
    VerticalNavMenu,
    IonContent,
    IonPage,
    IonSpinner,
    Pagination,
  },
  setup() {

    // Constants
    const store         = useStore()
    const {updateTracker} = useDataChangeTracker()
    const leadStatuses  = store.state.general_data.leads_statuses
    const vueFlatPickerConfig = {
      altFormat: 'd-m-Y',
      altInput: true,
      mode: "range",
    }

    // Reactive objects
    let filters = reactive({
      search: '',
      status: '',
      form: '',
      city: '',
      date: '',
      display_order: ''
    })
    let pagination = reactive({
      page: 1,
      totalRecords: 0,
    })

    // Reactive variables
    let bulkSelectedAction = ref('')
    let cancelToken        = false
    let leads              = ref([])
    let loadingData        = ref(false)
    let searchBarActive    = ref(false)
    let selectAll          = ref(false)

    // Reactive function
    const bulkAction = async () => {
      let selectedRecords = []
      for(let x in leads.value){
        if( leads.value[x].selected){
          selectedRecords.push( leads.value[x])
        }
      }
      if( selectedRecords.length < 1 ){
        return false
      }
      if( bulkSelectedAction.value === 'withdraw'){
        await withdrawLeads( selectedRecords )
      }
    }
    const doSearch = (search) => filters.search = search
    const getLeads = async (reset) => {

      if(false !== cancelToken){
        cancelToken()
        cancelToken = false
      }
      loadingData.value = true
      axios.post('/api/admin/leads/assigned', {
            page: pagination.page,
            status: filters.status,
            search: filters.search,
            date_range: filters.date,
            order: filters.display_order
          },
          {
            cancelToken: new axios.CancelToken( c => {
              cancelToken = c
            })
          })
          .then( (resp) => {
            if(reset){
              leads.value = []
            }
            for(let x in resp.data.data){
              resp.data.data[x].selected = false;
              leads.value.push(resp.data.data[x]);
            }
            if(pagination.page === 1){
              pagination.totalRecords = resp.data.total_records
            }
          })
          .catch( err => {
            console.log('Invoices.vue ajax error: ', err)
          })
          .then(() => {
            cancelToken = false
            loadingData.value = false
          })
    }
    const paginationCallback = () => getLeads(true)
    const withdrawLeads = async ( _leads ) => {

      const loading = await loadingController.create({message: 'Processing...'})
      const toast   = await toastController.create({position: "top", duration: 3000})

      let ids = []
      for(let x in _leads){
        ids.push( _leads[x].id)
      }

      let iAlert = await alertController.create({
        cssClass: 'text-lg-left',
        header: `Withdraw lead${ids.length > 1 ? 's' : ''}`,
        message: `Are you sure to withdraw ${ids.length > 1 ? ' the selected leads' : 'this lead'}`,
        buttons: [
          'Cancel',
          {
            text: 'Confirm', handler: () => {

              loading.present()
              axios.post('/api/admin/leads/assigned/withdraw', {ids: JSON.stringify(ids)})
                  .then( resp => {
                    toast.message = resp.data.success ? 'Thank you! leads withdrawn, you may see it in the leads list.' : resp.data.message
                    toast.color   = resp.data.success ? "primary" : "danger"
                    if(resp.data.success){
                      updateTracker('admin', ['leads_list'])
                      // Remove the selected leads from the leads array
                      for(let x in ids){
                        for(let y in leads.value){
                          if(leads.value[y].id === ids[x]){
                            leads.value.splice(y,1)
                            break;
                          }
                        }
                      }
                      // All deleted, no entry left in the advisor array? and previous pages exists
                      if( !leads.value.length && pagination.page > 1 ){
                        // Deduct from total records value
                        pagination.totalRecords -= ids.length
                        // Goto previous page
                        pagination.page--
                        getLeads(true)
                      }
                    }
                    toast.present()
                  })
                  .catch(error => {
                    toast.message = 'Error: '+error.response.status+' '+error.response.statusText
                    toast.color = "danger"
                    toast.present()
                  })
                  .then( () => loading.dismiss())
            }
          }
        ]
      })
      await iAlert.present()
    }

    // Watchers
    watch( ()=> filters.search, () => getLeads(true))
    watch(selectAll, (n) => {
      for(let x in leads.value){
        leads.value[x].selected = n
      }
    })
    // If a lead gets assigned or is withdrawn or deleted from the lead details page, we need to fetch fresh data
    watch( ()=> store.state.dataChangeTracker.admin.assigned_leads, (n) => {
      if(n){
        updateTracker('admin', ['assigned_leads'], false) // Reset tracker
        getLeads(true)
      }
    })

    // Mounted
    onMounted(()=> getLeads())

    // Returns
    return {
      bulkAction,
      bulkSelectedAction,
      doSearch,
      filters,
      getLeads,
      leads,
      leadStatuses,
      loadingData,
      pagination,
      paginationCallback,
      searchBarActive,
      selectAll,
      withdrawLeads,
      vueFlatPickerConfig,
    }

  }
});

</script>
